import React, { useState } from 'react';
import globalSettingsStores from '../../../../../stores/settings-stores';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import dateUtils from '../../../../../utils/date-format';
import { EditTextDialog } from '../../../componenets/edit-entity-name-dialog/edit-text-dialog';
import { updateEntityNameOperation } from '../../../operations/update-entity-name/update-entity-name-operation';
import { SettingsEntityType } from '../../../operations/update-entity-name/settings-entity-types';
import { observer } from 'mobx-react-lite';
import { CourseStudentStatus } from '../../../../../api/types/settings/studies/course-student-status';
import { AddCourseStudentStatusDialog } from './components/add-course-student-status-dialog';
import appApi from '../../../../../api/app-api';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';

export const SettingsCourseStudentStatuses = observer(() => {
  const [addNewStatus, setAddNewStatus] = useState(false);
  const [editStatus, setEditStatus] = useState<CourseStudentStatus | null>(
    null,
  );
  const [loading, setLoading] = useState(false);
  const [selectedStatuses, setSelectedStatuses] = useState<
    CourseStudentStatus[]
  >([]);
  const [deleteStatusId, setDeleteStatusId] = useState<number | null>(null);

  const handleDeleteStatus = async (statusId: number) => {
    // TODO: Implement delete operation similar to other settings
    setDeleteStatusId(statusId);
    try {
      const res = await appApi.deleteCourseStudentStatus(statusId);
      if (res.data.errCode) {
        toast.warn(displayErrorText(res.data.errCode));
        setDeleteStatusId(null);
        return;
      }
      await globalSettingsStores.fetchSetting();
    } finally {
      setDeleteStatusId(null);
    }
  };

  const handleEditStatus = (status: CourseStudentStatus) => {
    setEditStatus(status);
  };

  const handleSaveStatus = async (id: number, newName: string) => {
    await updateEntityNameOperation(
      SettingsEntityType.COURSE_STUDENT_STATUS,
      id,
      newName,
      setLoading,
    );
  };

  return (
    <div>
      <Button
        onClick={() => setAddNewStatus(true)}
        style={{ height: '30px' }}
        label={'הוספה'}
      />

      <Dialog
        header="הוספת סטטוס תלמיד"
        visible={addNewStatus}
        onHide={() => setAddNewStatus(false)}
        style={{
          width: '500px',
          backgroundColor: 'white',
          borderRadius: '8px',
        }}
      >
        <AddCourseStudentStatusDialog onHide={() => setAddNewStatus(false)} />
      </Dialog>

      <EditTextDialog
        id={editStatus?.id}
        value={editStatus?.statusName}
        title="עריכת סטטוס תלמיד"
        label="שם הסטטוס"
        loading={loading}
        onSave={handleSaveStatus}
        onHide={() => setEditStatus(null)}
      />

      <DataTable
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        selectionMode="multiple"
        selection={selectedStatuses}
        onSelectionChange={(e) => setSelectedStatuses(e.value)}
        value={globalSettingsStores.courseStudentStatuses}
        dataKey="id"
        tableStyle={{
          direction: 'rtl',
          marginTop: '16px',
        }}
      >
        <Column style={{ textAlign: 'right' }} field="statusName" header="שם" />

        <Column
          style={{ textAlign: 'right' }}
          field="createdByName"
          header="נוצר ע״י"
        />

        <Column
          style={{ textAlign: 'right' }}
          field="createdAt"
          header="נוצר בתאריך"
          body={(rowData: CourseStudentStatus) => (
            <div>{dateUtils.displayFormatDate(rowData.createdAt)}</div>
          )}
        />

        <Column
          style={{ textAlign: 'right' }}
          field="פעולות"
          header=""
          body={(data: CourseStudentStatus) => (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <Button
                icon="pi pi-pencil"
                text
                severity="warning"
                tooltip={'עריכת סטטוס'}
                onClick={() => handleEditStatus(data)}
              />
              <Button
                icon="pi pi-trash"
                text
                severity="danger"
                tooltip={'מחיקת סטטוס'}
                loading={deleteStatusId === data.id}
                disabled={deleteStatusId !== null}
                onClick={() => handleDeleteStatus(data.id)}
              />
            </div>
          )}
        />
      </DataTable>
    </div>
  );
});
